import { memo } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { Skeleton } from "../shadcn/skeleton";

type Props = {
  isDarkTheme?: string;
  roundedDefault?: boolean;
  roundedFull?: boolean;
  text?: string;
  className?: string;
};

export const LoadingPlaceholder = memo(
  ({ roundedDefault, roundedFull, text = "", className }: Props) => (
    <Skeleton
      className={cnTwMerge(
        "w-full h-full",
        isTruthy(roundedFull) ? "rounded-full before:rounded-full" : "",
        isTruthy(roundedDefault)
          ? "rounded-default before:rounded-default"
          : "",
        className,
      )}
      role="progressbar"
    >
      {text ? <span className="ml-2">{text}</span> : null}{" "}
    </Skeleton>
  ),
);
